import Vue from 'vue'
import Vuex from 'vuex'

import account from './modules/account'
import profile from './modules/profile'
import autocomplete from './modules/autocomplete'
import hotelsSearch from './modules/hotelsSearch'
import toursSearch from './modules/toursSearch'
import cart from './modules/cart'
import orders from './modules/orders'
import order from './modules/order'
import dictionaries from './modules/dictionaries'
import favorites from './modules/favorites'
import sale from './modules/sale'
import myAgency from './modules/myAgency'
import rates from './modules/rates'
import events from './modules/events'
import lk from './modules/lk'
import contacts from './modules/contacts'
import payment from './modules/payment'
import subscription from './modules/subscription'
import fit from './modules/fit'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    profile,
    autocomplete,
    hotelsSearch,
    toursSearch,
    cart,
    orders,
    order,
    dictionaries,
    favorites,
    sale,
    myAgency,
    rates,
    events,
    lk,
    contacts,
    payment,
    subscription,
    fit
  },
})